<template>
  <v-container fluid class="activity-tab-view ma-0 pa-0" fill-height>
    <portal to="context-portal">
      <activity-header-2 :activity="activity"/>
    </portal>
    <div v-if="isLoading" class="d-flex" style="width: 100%">
      <!-- <v-progress-circular
                indeterminate
                size="20"
                class="mr-1"
      ></v-progress-circular>-->
      <h2 class="text-xs-center">loading activity...</h2>
    </div>
    <v-tabs
      v-if="!isLoading"
      centered
      icons-and-text
      class="dense-tabs"
      style="align-self: stretch;width: 100%;"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab href="#map-tab">Map
        <v-icon>map</v-icon>
      </v-tab>

      <v-tab href="#profile-tab">Profile
        <v-icon>landscape</v-icon>
      </v-tab>

      <v-tab href="#segments-tab">Segments
        <v-icon>timeline</v-icon>
      </v-tab>

      <v-tab href="#stats-tab">Stats
        <v-icon>equalizer</v-icon>
      </v-tab>

      <v-tab href="#tab-2">Images
        <v-icon>photo_camera</v-icon>
      </v-tab>

      <v-tab-item value="map-tab">
        <l-map-view
          ref="map"
          style="height: 100%;"
          :polyline="polyline"
          :bounds="bounds"
          :show-attribution="false"
        />
      </v-tab-item>
      <v-tab-item value="profile-tab">
        <elevation-profile :points="points"/>
      </v-tab-item>
      <v-tab-item value="stats-tab">
        <activity-stats :activity="activity"/>
      </v-tab-item>
      <v-tab-item value="segments-tab">
        <activity-segments
          class="segment-full-screen"
          :segments="activity && activity.segment_efforts ? activity.segment_efforts : []"
          @item-hover="(a) => hoveredSegment = a"
        />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import dataAccessor from '@/data-access/dataAccessor';
import MapView from '@/ux/generic-components/MapView.vue';
import LMapView from '@/ux/generic-components/LMapView.vue';
import ActivitySegments from '@/ux/components/activities/ActivitySegments.vue';
import ActivityStats from '@/ux/components/activities/ActivityStats.vue';
import ActivityHeader2 from '@/ux/components/headers/ActivityHeader2.vue';
import ActivityHeader from '@/ux/components/headers/ActivityHeader.vue';
import ElevationProfile from '@/ux/generic-components/ElevationProfile.vue';
import loadingMixin from '@/mixins/loadingMixin';
import sizeAwareMixin from '@/mixins/sizeAwareMixin';
import PolylineDecoder from '@/library/PolylineDecoder';
import geometry from '@/library/Geometry';
import activity from '@/routes/activity';

export default {
  name: 'activity-detail-view',
  components: { LMapView, MapView, ActivitySegments, ActivityHeader, ElevationProfile, ActivityHeader2, ActivityStats },
  props: {
    id: {
      type: [Number, String],
      required: true,
      default: null,
    },
  },
  mixins: [loadingMixin, sizeAwareMixin],
  data: () => ({
    activity: {},
    polyline: null,
    hoveredSegment: null,
    mapOnly: false,
    points: [],
  }),
  computed: {
    bounds() {
      let bnds = null;
      if (this.hoveredSegment) {
        bnds = geometry.bounds([geometry.toLatLng(this.hoveredSegment.segment.start_latlng),
        geometry.toLatLng(this.hoveredSegment.segment.end_latlng)]);
      }
      return bnds;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loadingStart(`Loading activity`);
      const d = new PolylineDecoder();
      this.activity = await dataAccessor.getActivity(this.id);
      this.points = await dataAccessor.getActivityStreams(this.id);
      this.centre = { lat: this.activity.start_latlng[0], lng: this.activity.start_latlng[1] };
      this.polyline = this.activity && this.activity.map ? this.activity.map.polyline : [];
      this.loadingEnd();
      this.attachMapButtons();
    },
    attachMapButtons() {
      // this.$refs.map.addButton('image', `Activity elevation profile`, () => {
      //   this.$router.push({ name: 'activityProfile', params: { id: this.id } });
      // });
      // if (this.activity.photos.count > 0) {
      //   this.$refs.map.addButton('photo_camera', `${this.activity.photos.count} x photo(s)`, () => { });
      // }
      // if (this.activity.segment_efforts.length > 0) {
      //   this.$refs.map.addButton('timeline', `${this.activity.segment_efforts.length} x segment(s)`, () => {
      //     this.$router.push({ name: 'activitySegmentEfforts', params: { id: this.id } });
      //   });
      // }
    },
  },
};
</script>


<style lang="scss">
.activity-tab-view {
  .segment-full-screen {
    overflow-y: auto;
    height: 100%;
  }
  .v-tab__item {
    padding: 0px;
  }

  .v-window {
    height: 100%;
    .v-window__container {
      height: 100%;
    }
    .v-window-item {
      height: 100%;
    }
  }
}
</style>